import { render } from "./no-data.vue?vue&type=template&id=e267a940&scoped=true&ts=true"
import script from "./no-data.vue?vue&type=script&lang=ts"
export * from "./no-data.vue?vue&type=script&lang=ts"

import "./no-data.vue?vue&type=style&index=0&id=e267a940&lang=stylus&scoped=true"

import exportComponent from "D:\\Front-end-project\\anxin-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e267a940"]])

export default __exports__